// imports
import { fetchConfig as fetchConfigThunk } from './lib/config';
import {
  fetchHeroes as fetchHeroesThunk,
  updateHeroesChain as updateHeroesChainThunk,
  fetchBackpackItems as fetchBackpackItemsThunk
} from './lib/inventory';
import {
  startQuest as startQuestThunk,
  claimRewards as claimRewardsThunk,
  completeQuest as completeQuestThunk,
  setQuestTimer as setQuestTimerThunk,
  fetchQuestsProgress as fetchQuestsProgressThunk
} from './lib/quests';
import {
  fetchPreferences as fetchPreferencesThunk,
  updatePreferences as updatePreferencesThunk,
  resetPreferencesUpdateStatus as resetPreferencesUpdateStatusThunk
} from './lib/preferences';
import {
  fetchDelegateWallet as fetchDelegateWalletThunk,
  resetDelegateWallet as resetDelegateWalletThunk,
  updateDelegateWallet as updateDelegateWalletThunk
} from './lib/delegateWallet';

// exports
export const fetchConfig = fetchConfigThunk;

export const fetchHeroes = fetchHeroesThunk;
export const updateHeroesChain = updateHeroesChainThunk;
export const fetchBackpackItems = fetchBackpackItemsThunk;

export const startQuest = startQuestThunk;
export const claimRewards = claimRewardsThunk;
export const completeQuest = completeQuestThunk;
export const setQuestTimer = setQuestTimerThunk;
export const fetchQuestsProgress = fetchQuestsProgressThunk;

export const fetchPreferences = fetchPreferencesThunk;
export const updatePreferences = updatePreferencesThunk;
export const resetPreferencesUpdateStatus = resetPreferencesUpdateStatusThunk;

export const fetchDelegateWallet = fetchDelegateWalletThunk;
export const resetDelegateWallet = resetDelegateWalletThunk;
export const updateDelegateWallet = updateDelegateWalletThunk;
